<template>
    <div>
        <base-header type="gray-100" class="pb-6 pb-8 pt-20 pt-md-6">

            <!-- Loading-->
            <template v-if="loading">
                <div class="m-4 mt-4">
                    <skeleton altura="30px" :velocidade="2.2" :atraso="0.2" :itens="1" classItem="mb-2"></skeleton>
                </div>
                <div class="m-4">
                    <skeleton altura="130px" :velocidade="2.2" :atraso="0.2" :itens="1" classItem="mb-2"></skeleton>
                </div>
                <div class="m-4">
                    <skeleton altura="50px" :velocidade="2.2" :atraso="0.2" :itens="1" classItem="mb-2"></skeleton>
                </div>
                <div class="m-4">
                    <skeleton altura="300px" :velocidade="2.2" :atraso="0.2" :itens="1" classItem="mb-2"></skeleton>
                </div>
            </template>

             <!-- SearchDate Inputs -->
             <div class="row text-right mb-4"  v-if="!loading">
                <div class="col-xl-12 col-lg-12" style="display: flex; justify-content: end; margin-top: 30px">
                    <div class="ml-4">
                        <base-button class="inline" :to="'/financeiro/cadastro'">Nova Conta</base-button>
                    </div>
               </div>
             </div>

            <!-- Card stats -->
            <div class="row" v-if="!loading">
                <div class="col-xl-4 col-lg-4">
                    <stats-card title="Geral"
                                type="gradient-primary"
                                v-bind:sub-title="contasInfo.total"
                                icon="fas fa-exclamation"
                                class="mb-4 mb-xl-0"
                    >

                        <template slot="footer">
                            <span class="text-light">contas totais mensais.</span>
                        </template>
                    </stats-card>
                </div>
                <div class="col-xl-4 col-lg-4">
                    <stats-card title="Recebimentos"
                                type="gradient-primary"
                                v-bind:sub-title="contasInfo.receber"
                                icon="fas fa-arrow-down"
                                class="mb-4 mb-xl-0"
                    >

                        <template slot="footer">
                            <span class="text-light">contas de recebimento.</span>
                        </template>
                    </stats-card>
                </div>

                <div class="col-xl-4 col-lg-4">
                    <stats-card title="Pagamentos"
                                type="gradient-primary"
                                v-bind:sub-title="contasInfo.pagar"
                                icon="fas fa-arrow-up"
                                class="mb-4 mb-xl-0"
                    >

                        <template slot="footer">
                            <span class="text-light">contas de pagamento.</span>
                        </template>
                    </stats-card>
                </div>

            </div>

             <!-- SearchDate Inputs -->
             <div class="row text-right mb-4"  v-if="!loading">
                <div class="col-xl-12 col-lg-12" style="display: flex; justify-content: end; margin-top: 30px; align-items: center">
                    <v-select  :options="yearList"  label="nomeCompleto" class="form-control-alternative select-date" v-model="dadosBuscar.ano" placeholder="Ano">
                        <template #option="option">
                            {{ option.nomeCompleto }}
                        </template>
                    </v-select>
                    <v-select  :options="monthList"  label="nomeCompleto" class="form-control-alternative select-date" v-model="dadosBuscar.mes" placeholder="Mês">
                        <template #option="option">
                            {{ option.nomeCompleto }}
                        </template>
                    </v-select>
                    <div class="ml-4">
                        <base-button size="md" class="inline" type="info"  @click="initLoad(true)">Filtrar</base-button>
                    </div>
               </div>
             </div>

            <div class="row" v-if="!loading && !loading2">
                <div class="mt-2 mb-2 col-xl-6 col-lg-12"  v-for="(table, index) in tables" :key="index">
                    <div class="card shadow">
                        <div class="card-header border-0 bg-primary">
                            <div class="row align-items-center">
                            <div class="col head">
                                <h3 class="mb-0 text-white">
                                <i :class="table.icon"></i>
                                {{ table.label }}
                                </h3>
                            </div>
                            </div>
                        </div>
                        <div class="table-responsive">
                            <template>
                                <base-table class="table align-items-center table-flush" tbody-classes="list" :data="index == 0 ? contasReceberList : contasPagarList">
                                    <template slot="columns">
                                        <th>Descritivo</th>
                                        <th class="text-right">Valor</th>
                                        <th class="text-center">Parc.</th>
                                        <th class="text-center">Vencimento</th>
                                        <th class="text-center">Status</th>
                                        <th class="text-center">-</th>
                                    </template>

                                    <template slot-scope="{row}">
                                        <td>
                                            {{ row.descritivo }}
                                        </td>
                                        <td class="text-right">
                                            <span class="small-value">
                                                (R$ {{ row.valor_total.toLocaleString('pt-br', {minimumFractionDigits: 2}) }})
                                            </span>
                                            R$ {{ row.valor.toLocaleString('pt-br', {minimumFractionDigits: 2}) }}
                                        </td>
                                        <td class="text-center">
                                            <span v-if="row.parcelamento < 1"> - </span>
                                            <span v-if="row.parcelamento > 0">{{ row.parcelamento }} / {{ row.parc_total }}</span>
                                        </td>
                                        <td class="text-center">
                                            {{ formatarData2( row.data_vencimento ) }}
                                        </td>
                                        <td class="text-center">
                                            <badge class="" :type="setStatus(row, 'color')">
                                                {{ setStatus(row, 'label') }}
                                            </badge>
                                        </td>
                                        <td class="text-center">
                                            <router-link :to="'/financeiro/cadastro/' + row.id" title="Visualizar">
                                                <i class="fas fa-edit"></i>
                                            </router-link>
                                        </td>
                                    </template>
                                </base-table>
                            </template>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Loading-->
            <template v-if="loading2">
                <div class="m-4">
                    <skeleton altura="300px" :velocidade="2.2" :atraso="0.2" :itens="1" classItem="mb-2"></skeleton>
                </div>
            </template>
        </base-header>
    </div>  
</template>
<script>

  // data import
  import financeiro from '@/cflow/financeiro.js'
  import vSelect from "vue-select";
  import "vue-select/dist/vue-select.css";

  // Tables

  export default {
    components: {
        vSelect
    },
    data() {
      return {
        tables: [
            { id: 0, label: 'Recebimentos', icon: 'fas fa-arrow-down' },
            { id: 0, label: 'Pagamentos', icon: 'fas fa-arrow-up' }
        ],
        loading: true,
        loading2: false,
        yearList: [],
        monthList: [],
        contasReceberList: [],
        contasPagarList: [],
        contasInfo: {
            total: ' - ',
            receber:  ' - ',
            pagar:  ' - '
        },
        dadosBuscar: {
            ano: null,
            mes: null
        },
      };
    },
    methods: {
      initLoad: function(loading2 = false) {

        const _this = this;

        if(loading2 === true) {
            _this.loading2 = true;
        }

        const ano = _this.dadosBuscar.ano;
        const mes = this.monthList.indexOf(_this.dadosBuscar.mes);

        financeiro.listar(ano, mes).then( contas => {

            const contasPagar = contas.filter(item => item.tipo === 'PAGAR');
            const contasReceber = contas.filter(item => item.tipo === 'RECEBER');

            _this.contasInfo = {
                total: contas.length,
                receber:  contasReceber.length,
                pagar:  contasPagar.length
            }

            _this.contasReceberList = contasReceber;
            _this.contasPagarList = contasPagar;

            _this.loading2 = false;
            _this.loading = false;

        })
      },
      setStatus: function(row, flag) {
        let status = {
          label: null,
          value: null
        }

        const now = new Date().setHours(18, 0, 0, 0);
        const venc = new Date(row.data_vencimento).setHours(18, 0, 0, 0);

        if(row.pago == 1) {
          status.label = 'Pago';
          status.color = 'success';
        }

        if(row.pago == 0 && now == venc) {
          status.label = 'vencendo';
          status.color = 'warning';
        }

        if(row.pago == 0 && now < venc) {
          status.label = 'Pendente';
          status.color = 'info';
        }

        if(row.pago == 0 && now > venc) {
          status.label = 'Vencido';
          status.color = 'danger';
        }

        return status[flag];

      },
      getMonthList: function(key = false) {
        const months = ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'];
        if(key !== false) return months[key];
        return months;
      },
      getYearList: function() {
        const firstYear = 2023;
        const currentYear = new Date().getFullYear();
        let yearList = [];
        for(let i = currentYear; i >= firstYear; i--) {
            yearList.push(i);
        }
        return yearList;
      }
    },
    mounted() {
        const _this = this;
        _this.yearList = _this.getYearList();
        _this.monthList = _this.getMonthList();

        const now = new Date();
        _this.dadosBuscar = {
            ano: now.getFullYear(),
            mes: _this.getMonthList(now.getMonth())
        }

        _this.initLoad();
    }
  };
</script>
<style>
.v-select {
    width: 200px !important;
}
.select-date {
    margin: 0px 5px;
}
.small-value {
    font-size: 10px;
    margin-right: 10px;
}
</style>
